module.exports = __webpack_public_path__ + "7d7436265ee212b42a486015152d8aea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dev/logo.png
// module id = 1838
// module chunks = 0